import {Component, Input, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../subscribe/subscribe.component";

@Component({
    selector: 'app-about',
    standalone: true,
    templateUrl: './about.component.html',
    imports: [
        RouterLink,
        SubscribeComponent
    ],
    styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

    @Input() isOnHome: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
